(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('YieldCurvePointOpen', YieldCurvePointOpen);

    YieldCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function YieldCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/yield-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
